// This hook checks if sticky element should be used
import { useEffect, useState } from 'react';

export const useCheckIsSticky = (stickyMenuRef, stickyHeaderHeight, isSectionScrolled) => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    if (!stickyMenuRef?.current) {
      setIsSticky(isSectionScrolled);
      return () => {};
    }

    const element = null;
    const options = { root: element, threshold: 0, rootMargin: `-${stickyHeaderHeight}px 0px 0px 0px` };
    const observer = new IntersectionObserver(observerCallback, options);
    const target = stickyMenuRef.current;

    observer.observe(target);

    return () => observer.disconnect();

    function observerCallback(entries) {
      const entry = entries[0];

      if (!isSectionScrolled || entry.isIntersecting) {
        setIsSticky(false);
        return;
      }

      setIsSticky(true);
    }
  }, [stickyHeaderHeight, isSectionScrolled]);

  return isSticky;
};
